import { createClient } from "@supabase/supabase-js";

const SUPABASE_URL = 'https://ioclibnpcwbwnpmoioku.supabase.co'; 
const SUPABASE_ANON_KEY =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImlvY2xpYm5wY3did25wbW9pb2t1Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDMxNzYxMjYsImV4cCI6MjA1ODc1MjEyNn0.3zSMupTg5FnSAJXGk5F9y8rGEvKmtGizLlntx0U3QOA';

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);
